import script from "./ObjectsListTableSettingsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectsListTableSettingsModal.vue?vue&type=script&setup=true&lang=js"

import "./ObjectsListTableSettingsModal.vue?vue&type=style&index=0&id=04eaf462&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04eaf462"]])

export default __exports__